import React from 'react';
import { useSelector } from 'react-redux';

import { DoubleRightOutlined } from '@ant-design/icons';
import ButtonSmallIcon from 'common/components/button/ButtonSmallIcon';
import gridSelector from 'common/components/grid-view/controllers/selectors';

import selectorUser from '@redux/user/selectors';

import * as assetFullSelectors from 'pages/asset-full-view/controllers/selectors';

import { checkIsSuperAdmin } from 'utils';
import { useGlobalModal } from 'hooks';

import { useUserInfo } from 'hooks/auth/useUserInfo';

const MoveAssetsToMember = (props) => {
  const { disabled, viewType } = props;

  const {
    userInfo
  } = useUserInfo();

  const isSuperAdmin = checkIsSuperAdmin(userInfo?.roles);

  const selectedItemDetailList = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const assetData = useSelector(assetFullSelectors.assetDataLoading());

  const { MODAL_NAMES, openModal } = useGlobalModal();

  const openModalMoveAssetToMember = () => {
    // refSearchGridItemModal.current.openModal();
    openModal(MODAL_NAMES.MOVE_ASSET_TO_MEMBER);
  };

  const checkDisabledBtn = () => {
    if (!selectedItemDetailList?.length && !assetData) return true;

    if (userInfo?.isSuperMember || isSuperAdmin) return false;

    return true;
  };

  const isDisabledBtn = checkDisabledBtn();

  const assetList =
    selectedItemDetailList?.length > 0
      ? selectedItemDetailList
      : assetData
      ? [assetData]
      : [];

  return (
    <>
      <ButtonSmallIcon
        className='button-item-dropdown'
        icon={<DoubleRightOutlined />}
        textDisplay={
          viewType === 'assetFullView'
            ? 'Move Asset to Member'
            : 'Move Assets to member'
        }
        onClick={openModalMoveAssetToMember}
        disabled={isDisabledBtn || disabled}
      />
    </>
  );
};

MoveAssetsToMember.propTypes = {};

export default MoveAssetsToMember;
